import { FormattedMessage as FM } from "react-intl";

import TableCustomFilter from "componentsv2/experimental/TableCustomFIlter";
import ToolButton from "componentsv2/button/ToolButton";

import { cn } from "tools/ui";
import { TableListIcon, SquaresPlusIcon } from "components/Icons";
import SearchWidget from "componentsv2/widgets/SearchWidget";

const STYLE_ITEM =
  "flex space-x-2 items-center cursor-pointer bg-neutral-200 px-3 py-1 rounded-full border border-neutral-400/30 shadow";

function HeaderColumn({
  title,
  times,
  layout,
  storeId,
  filterSemaphore,
  setFilterSemaphore,
  getDomain,
  setSearchDomain,
  setFilterDomain,
  kanbanHideTimes = false,
  kanbanHideSearch = false,
  setView,
  handleAdd,
}) {
  function LabelTime({ label, style, key, active }) {
    return (
      <div
        className={cn(
          STYLE_ITEM,
          active
            ? "!bg-neutral-800 text-white shadow-2xl! border-amber-500! border-2!"
            : "text-gray-700 ",
        )}
        onClick={() => setFilterSemaphore(label)}
        onDoubleClick={() => setFilterSemaphore(null)}
      >
        <div className={cn("rounded-full size-3", style)} />
        <span className="text-[15px] font-medium">
          <FM id={label} />
        </span>
      </div>
    );
  }

  const availableViews =
    layout.availableViews?.length > 0 ? layout.availableViews : [];
  const currentViewValue = setView?.value;

  return (
    <div className="mt-5">
      <div className="flex max-md:flex-col max-md:items-start h-full py-1 my-3 max-md:mt-10 items-center justify-between px-3">
        <div className="flex mr-10 md:my-auto text-neutral-500">
          <span className="truncate font-light text-2xl md:text-4xl">
            <FM id={title || "Kitchen Display System (KDS)"} />
          </span>
        </div>
        <div className="flex space-x-2 items-center">
          {!kanbanHideSearch && (
            <div className="w-full md:w-[500px] !text-[20px]">
              <SearchWidget
                layout={layout}
                storeId={storeId}
                count={0}
                getDomain={getDomain}
                setSearchDomain={setSearchDomain}
              />
            </div>
          )}
          {handleAdd && (
            <ToolButton
              action="add"
              label="button.add"
              handleAction={handleAdd}
            />
          )}
          {availableViews.length > 1 && (
            <div className="flex space-x-1 border-l border-gray-300 pl-2 ml-2">
              {availableViews.map((viewName) => (
                <button
                  type="button"
                  key={viewName}
                  onClick={() => {
                    setView.value = viewName;
                  }}
                  className={`!w-12 h-10 flex items-center justify-center rounded-xl transition-colors border-none cursor-pointer ${
                    currentViewValue === viewName
                      ? "bg-amber-100 ring-2 ring-amber-200"
                      : "bg-gray-200 hover:bg-gray-300"
                  }`}
                  title={viewName}
                >
                  {viewName === "list" ? (
                    <TableListIcon className="h-6 w-6" />
                  ) : (
                    <SquaresPlusIcon className="h-6 w-6" />
                  )}
                </button>
              ))}
            </div>
          )}
          {!kanbanHideTimes && (
            <div className="flex space-x-3">
              <div className="bg-gray-100 rounded-2xl flex space-x-3 items-center">
                {times.map((item) => (
                  <LabelTime
                    key={item.key}
                    label={item.label}
                    style={item.style}
                    active={item.label === filterSemaphore}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="mx-2 my-3 flex space-x-3">
        <TableCustomFilter
          layout={layout}
          storeId={storeId}
          setFilterDomain={setFilterDomain}
        />
      </div>
    </div>
  );
}

export default HeaderColumn;
